import React from 'react';
import { connect } from 'react-redux';
import { Button, Modal } from 'react-bootstrap';
import { translate } from 'react-i18next';
import MaterialTransparentDetail from '../../components/material_opaque/MaterialTransparentDetail';
import { createMaterialTransparent } from '../../redux/material_transparent/material_actions';
import { defaultRejectHandler, fromMilli } from '../../utils/utility';

export class MaterialTransparentCreateModal extends React.Component {
  constructor(props) {
    super(props);
    this.materialDetail = null;

    this.state = {
      isValid: false,
      isDirty: false,
      isSubmittable: false,
    };
  }

  onSaveHandler() {
    const newMaterial = this.materialDetail.getWrappedInstance().getMaterialData();
    this.props.createMaterial(newMaterial);
  }

  render() {
    const { isCreating, errorMessage, t, ...newProps } = this.props;
    const { isSubmittable } = this.state;

    return (
      <Modal
        {...newProps}
        bsSize="large"
        aria-labelledby="contained-modal-title-lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('create transparent material')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <MaterialTransparentDetail
            ref={ref => (this.materialDetail = ref)}
            onValid={isValid => this.setState({ isValid })}
            onDirty={isDirty => this.setState({ isDirty })}
            onSubmittable={isSubmittable => this.setState({ isSubmittable })}
            fieldErrors={errorMessage}
            onSubmit={() => !this.props.isCreating && !this.props.isCreated && this.onSaveHandler()}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="material-transparent-submit-create"
            disabled={!isSubmittable || isCreating}
            onClick={() => this.onSaveHandler()}
          >
            {this.props.isCreating ? `${t('creating')}...` : t('create')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  errorMessage: state.material.transparent.errorMessage,
  isCreating: state.material.transparent.isCreating,
});

const mapDispatchToProps = dispatch => ({
  createMaterial: material =>
    defaultRejectHandler(
      dispatch(
        createMaterialTransparent(
          material.name,
          fromMilli(material.thickness),
          material.SHGC,
          material.U,
          material.transmittance,
          material.description || '',
          material.image,
        )
      )
    ),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(MaterialTransparentCreateModal)
);



// WEBPACK FOOTER //
// ./src/modal/material_transparent/MaterialTransparentCreateModal.js